import { render, staticRenderFns } from "./CategoryInput.vue?vue&type=template&id=0a6eaed9&scoped=true&"
import script from "./CategoryInput.vue?vue&type=script&lang=js&"
export * from "./CategoryInput.vue?vue&type=script&lang=js&"
import style0 from "./CategoryInput.vue?vue&type=style&index=0&id=0a6eaed9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6eaed9",
  null
  
)

export default component.exports